// ============================================
// AUTH SERVICE
// Ported from old/src/api/services/auth.js
// Same endpoints, same payloads — TypeScript typed
// ============================================

import apiCall from '@/lib/api';
import { API_METHOD, AUTH } from '@/services/endpoints';
import type {
  LoginPayload,
  LoginResponse,
  SendOtpPayload,
  VerifyOtpPayload,
  ForgotPasswordPayload,
  ChangePasswordPayload,
  RefreshTokenResponse,
} from '@/types/auth.types';

export const signInApi = (data: LoginPayload) =>
  apiCall<LoginResponse>({
    type: API_METHOD.POST,
    url: AUTH.USER_LOGIN,
    body: data as unknown as Record<string, unknown>,
  });

export const logOut = (data?: Record<string, unknown>) =>
  apiCall({
    type: API_METHOD.POST,
    url: AUTH.LOGOUT,
    body: data,
  });

export const changePassword = (data: ChangePasswordPayload) =>
  apiCall({
    type: API_METHOD.POST,
    url: AUTH.CHANGE_PASSWORD,
    body: data as unknown as Record<string, unknown>,
  });

export const verifyOtp = (data: VerifyOtpPayload, otpVerificationToken: string) =>
  apiCall({
    type: API_METHOD.POST,
    url: AUTH.VERIFY_OTP,
    body: data as unknown as Record<string, unknown>,
    headers: {
      Authorization: `Bearer ${otpVerificationToken}`,
    },
  });

export const sendOtp = (data: SendOtpPayload) =>
  apiCall({
    type: API_METHOD.POST,
    url: `${AUTH.SEND_OTP}?userType=MASTER_ADMIN`,
    body: data as unknown as Record<string, unknown>,
  });

export const forgotPassword = (data: ForgotPasswordPayload, token: string) =>
  apiCall({
    type: API_METHOD.POST,
    url: AUTH.FORGOT_PASSWORD,
    body: data as unknown as Record<string, unknown>,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const refreshTokenApi = (refreshToken: string) =>
  apiCall<RefreshTokenResponse>({
    type: API_METHOD.POST,
    url: AUTH.REFRESH_TOKENS,
    body: { refreshToken },
  });
